module.exports = __webpack_public_path__ + "static/media/2.75x1.25-203dpi.ab6cd30a.png";